import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ThemeProvider, theme } from '@lusha-ui/theme';
import React from 'react';
function AppContext(props) {
    return _jsx(ThemeProvider, { theme: theme, children: props.children });
}
export default AppContext;
